const loginValue = (object) => ({
  Email: "",
  Password: "",
  errormsg: "",
  UserType:'college'
});

export default loginValue;
